import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { RangeSlider } from '@shopify/polaris';
import { Minus } from '@styled-icons/boxicons-regular/Minus';
import { Plus } from '@styled-icons/boxicons-regular/Plus';
import { Icon } from '@nile/components';
import { getHeaderValue } from '@nile/components';

const ImageViewer = (props) => {
  const { url, alt, token } = props;
  const [rangeValue, setRangeValue] = useState(1);
  const [imageSrc, setImageSrc] = useState('');

  useEffect(() => {
    let objectUrl = '';
    if (!token) {
      setImageSrc(url);
      return;
    }

    const fetchImage = async () => {
      try {
        const response = await fetch(url, {
          headers: { ...getHeaderValue(), authorization: `Bearer nl-${token}` }
        });
        const blob = await response.blob();
        objectUrl = URL.createObjectURL(blob);
        setImageSrc(objectUrl);
      } catch (error) {
        console.error('Error fetching image:', error);
        // Fallback to direct URL if fetch fails
        setImageSrc(url);
      }
    };

    if (url) {
      fetchImage();
    }

    // Cleanup function to revoke object URL
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url, token]);

  const handleRangeSliderChange = useCallback(
    (value) => setRangeValue(value),
    []
  );
  return (
    <ImageViewerContainer rangeValue={rangeValue}>
      {imageSrc && <img className="image" src={imageSrc} alt={alt || ''} />}
      <div className="range-slider">
        <Icon width={20} height={30} icon={Minus} />
        <RangeSlider
          output={false}
          label=""
          value={rangeValue}
          onChange={handleRangeSliderChange}
          max={2}
          min={1}
          step={0.5}
        />
        <Icon width={20} height={30} icon={Plus} />
      </div>
    </ImageViewerContainer>
  );
};

export default ImageViewer;

const ImageViewerContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .Polaris-RangeSlider-SingleThumb__Input {
    --progress-lower: var(--p-interactive, #fff);
    --progress-upper: var(--p-override-transparent, #fff);
  }
  .range-slider {
    z-index: 5;
    background-color: #272727;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
  }
  .range-label {
    color: #fff;
    font-size: 34px;
    margin: 0px 10px;
  }
  .image {
    height: 500px;

    width: 700px;
    object-fit: contain;
    transition: transform 0.5s;
    transform: ${(props) => `scale(${props.rangeValue})`};
  }
`;
